<div class="content">
  <ion-spinner name="circles" class="spinner"></ion-spinner>
  <div class="info-text">
    <h3 data-cy="order-syncing-title">
      {{ 'i18n.loadingSpinnerMessage.orderTransferringTitle' | translate }}
    </h3>
    <p data-cy="order-syncing-description-text">
      {{ 'i18n.loadingSpinnerMessage.orderTransferringMessage' | translate }}
    </p>
    <p data-cy="order-navigate-warning-text">
      {{ 'i18n.loadingSpinnerMessage.orderTransferringWarning' | translate }}
    </p>
  </div>
</div>
